import type { Position, Steuersatz } from './warenkorb';

/**
 * Pfand und Leergut (Modul „pfand“, Handel): Einwegpfand auf Flaschen und Dosen ist
 * ein durchlaufender Posten (0 %, kein Umsatz, aber Bareingang und Umsatzzähler),
 * Mehrwegpfand folgt als Nebenleistung dem Steuersatz des Getränks (20 %).
 * Leergut ist die Rücknahme: dieselbe Position mit negativem Betrag. Beide sind
 * vom Bon-Rabatt ausgenommen. Beträge in Cent (Regel 5).
 */
export const PFAND_PRAEFIX = 'Pfand ';
export const LEERGUT_PRAEFIX = 'Leergut ';

export interface PfandArt {
  bezeichnung: string;
  cent: number;
  steuersatz: Steuersatz;
}

export const PFAND_ARTEN: readonly PfandArt[] = [
  { bezeichnung: 'Einweg Flasche/Dose', cent: 25, steuersatz: '0' },
  { bezeichnung: 'Mehrweg Flasche', cent: 20, steuersatz: '20' },
  { bezeichnung: 'Mehrweg Flasche klein', cent: 9, steuersatz: '20' },
  { bezeichnung: 'Mehrweg Kiste', cent: 300, steuersatz: '20' },
  { bezeichnung: 'Mehrweg Kiste klein', cent: 150, steuersatz: '20' },
];

export function istPfand(p: Pick<Position, 'bezeichnung'>): boolean {
  return p.bezeichnung.startsWith(PFAND_PRAEFIX) || p.bezeichnung.startsWith(LEERGUT_PRAEFIX);
}

/** Pfandposition (oder Leergut = Rücknahme mit negativem Betrag) für `menge` Stück. */
export function pfandPosition(art: PfandArt, menge: number, leergut: boolean): Position {
  if (!Number.isInteger(menge) || menge <= 0) {
    throw new RangeError('Menge muss eine ganze Zahl größer 0 sein');
  }
  return {
    bezeichnung: `${leergut ? LEERGUT_PRAEFIX : PFAND_PRAEFIX}${art.bezeichnung}`,
    menge,
    bruttoCent: (leergut ? -1 : 1) * art.cent * menge,
    steuersatz: art.steuersatz,
  };
}
